function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import ClickAwayable from "./ClickAwayable";
import { _MoreOptions, _CustomStyledDiv } from "../../style";
var OptionWrapper = /*#__PURE__*/function (_ClickAwayable) {
  _inherits(OptionWrapper, _ClickAwayable);
  var _super = _createSuper(OptionWrapper);
  function OptionWrapper() {
    var _this;
    _classCallCheck(this, OptionWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _super.call.apply(_super, [this].concat(args)), _this.onClick = function () {
      _this.props.onClick(_this.props.content);
    }, _assertThisInitialized(_this)));
  }
  _createClass(OptionWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_CustomStyledDiv, {
        className: "mo-option",
        onClick: this.onClick
      }, this.props.content);
    }
  }]);
  return OptionWrapper;
}(ClickAwayable);
var MoreOptions = /*#__PURE__*/function (_Component) {
  _inherits(MoreOptions, _Component);
  var _super2 = _createSuper(MoreOptions);
  function MoreOptions() {
    var _this2;
    _classCallCheck(this, MoreOptions);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return _possibleConstructorReturn(_this2, (_this2 = _super2.call.apply(_super2, [this].concat(args)), _this2.state = {
      opened: false
    }, _this2.setRef = null, _this2.onClickAway = function () {
      _this2.setState({
        opened: false
      });
    }, _this2.onOpen = function () {
      _this2.setState({
        opened: !_this2.state.opened
      });
    }, _this2.onOptionClick = function (content) {
      _this2.setState({
        opened: false
      });
      _this2.props.onOptionClick(content);
    }, _assertThisInitialized(_this2)));
  }
  _createClass(MoreOptions, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      var options = this.props.options;
      var opened = this.state.opened;
      return /*#__PURE__*/React.createElement(_MoreOptions, {
        innerRef: this.setRef
      }, /*#__PURE__*/React.createElement("div", {
        className: opened ? 'mo-icon opened' : 'mo-icon',
        onClick: this.onOpen
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesome, {
        name: "ellipsis-v"
      }))), /*#__PURE__*/React.createElement("div", {
        className: opened ? 'mo-options opened' : 'mo-options'
      }, options.map(function (x, index) {
        return /*#__PURE__*/React.createElement(OptionWrapper, {
          key: x,
          index: index,
          content: x,
          onClick: _this3.onOptionClick
        });
      })));
    }
  }]);
  return MoreOptions;
}(Component);
export default MoreOptions;